import { SeoHead } from '@/components/seo-head';
import { Redirect } from 'expo-router';
import React from 'react';

/**
 * Endereço antigo da política (`/legal`). A política mora em `/privacidade`
 * e os Termos só em `/terms`. Na Vercel, o 308 de `/legal` para
 * `/privacidade` fica no `vercel.json`; este redirecionamento cobre o app e
 * links internos antigos.
 */
export default function LegalRedirect() {
  return (
    <>
      <SeoHead title="Política de privacidade · Controlapag" path="/privacidade" noindex />
      <Redirect href="/privacidade" />
    </>
  );
}
